import cookie from "./cookie";

export default {
    getUtmTagsFromUrlOrCookie: function () {
        const searchParams = new URLSearchParams(window.location.search);

        //get all search params with a key starting with utm_
        const utmParams = Array.from(searchParams.entries()).filter((param) => param[0].startsWith("utm_"));

        if (utmParams.length > 0) {
            return utmParams;
        }

        const utmCookie = cookie.getCookie("sec_utm");

        if (utmCookie.length > 0) {
            return utmCookie.split("&").map((param) => param.split("="));
        }

        return utmParams;
    }
};